import {Component, OnInit} from '@angular/core';
import {RoutesConfig} from '@employee-configs/routes.config';
import {EmployeeBusinessService} from './core/services/business.service';
import {BehaviorSubject, Observable} from 'rxjs';
import * as SharedModels from '@shared-models/index';
import * as EmployeeModels from '@employee-models/index';
import {AdobeLaunchService} from '@ui-app/services/adobe-launch.service';
import {EmployeeDataAccessService} from './core/services/data-access.service';
import {filter, map, share, switchMap, tap} from 'rxjs/operators';
import {CookieConsentService} from '@ui-app/services/cookie-consent.service';

@Component({
    selector: 'employee-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
})
export class AppComponent implements OnInit {
    title = 'DBadgeEmployee-app';
    user$: Observable<EmployeeModels.DM.IUserData>;
    userPhotoFile$: Observable<Blob>;

    navigationItems: SharedModels.CM.NavigationItem[] = [
        {
            itemName: SharedModels.CE.NavigationItemNames.BadgeRequests,
            routerLink: RoutesConfig.pages.badgeRequests,
            // queryParams: {categoryId: SharedModels.CE.BadgeRequestsCategoryId.Prehire},
            availableForRoles: [
                SharedModels.CE.UserRoleEnum.SecurityUS,
                SharedModels.CE.UserRoleEnum.SecurityUSI,
                SharedModels.CE.UserRoleEnum.CsbaUS,
                SharedModels.CE.UserRoleEnum.CsbaUSI,
                SharedModels.CE.UserRoleEnum.FrontDesk,
                SharedModels.CE.UserRoleEnum.FrontDeskUSI,
                SharedModels.CE.UserRoleEnum.SeniorManagerUSI,
                SharedModels.CE.UserRoleEnum.ThirdPartyContractorApprover,
                SharedModels.CE.UserRoleEnum.IRCApprover,
            ]
        },
        {
            itemName: 'CLE',
            routerLink: '/cle',
            availableForRoles: [
                // EmployeeModels.DE.UserRoleEnum.CLE,
                // SharedModels.CE.UserRoleEnum.SecurityUSI
            ]
        },
        {
            itemName: SharedModels.CE.NavigationItemNames.PhotoReview,
            routerLink: RoutesConfig.pages.photoReview,
            availableForRoles: [
                SharedModels.CE.UserRoleEnum.CsbaUS,
                SharedModels.CE.UserRoleEnum.CsbaUSI,
                SharedModels.CE.UserRoleEnum.SecurityUS,
                SharedModels.CE.UserRoleEnum.SecurityUSI,
            ]
        },
        {
            itemName: SharedModels.CE.NavigationItemNames.UsersManagement,
            routerLink: RoutesConfig.pages.usersManagement,
            availableForRoles: [
                SharedModels.CE.UserRoleEnum.SecurityUSI
            ],
        },
        {
            itemName: SharedModels.CE.NavigationItemNames.BadgeValidityExtensions,
            routerLink: RoutesConfig.pages.badgeValidityExtensions,
            availableForRoles: [
                SharedModels.CE.UserRoleEnum.SecurityUSI,                    // 61 - Admin USI
                SharedModels.CE.UserRoleEnum.CsbaUSI,                        // 21 - Badging Officer USI
                SharedModels.CE.UserRoleEnum.SeniorManagerUSI,               // 81 - Senior Manager USI
                SharedModels.CE.UserRoleEnum.ThirdPartyContractorApprover,   // 12 - Third Party Contractor Approver
            ],
        },
        {
            itemName:'Admin',
            routerLink: RoutesConfig.pages.usersManagement,
            availableForRoles: [
                SharedModels.CE.UserRoleEnum.CsbaUS,
                SharedModels.CE.UserRoleEnum.SecurityUS
            ],
             childrenRouterLinks: [RoutesConfig.pages.usersManagement, RoutesConfig.pages.locations],
               children:  [
              {
                    itemName: SharedModels.CE.NavigationItemNames.UsersManagement,
                    routerLink: RoutesConfig.pages.usersManagement,
                    availableForRoles: [
                        SharedModels.CE.UserRoleEnum.CsbaUS,
                        SharedModels.CE.UserRoleEnum.SecurityUS
                    ],
                    queryParams: {}
                },
                {
                    itemName: SharedModels.CE.NavigationItemNames.Locations,
                    routerLink: RoutesConfig.pages.locations,
                    availableForRoles: [
                        SharedModels.CE.UserRoleEnum.CsbaUS,
                        SharedModels.CE.UserRoleEnum.SecurityUS
                    ],
                }
             ]
        },
        {
            itemName: SharedModels.CE.NavigationItemNames.MobileBadging,
            routerLink: RoutesConfig.pages.bulkProvision,
            availableForRoles: [
                SharedModels.CE.UserRoleEnum.CsbaUS,
                SharedModels.CE.UserRoleEnum.SecurityUS
            ],
            childrenRouterLinks: [RoutesConfig.pages.bulkProvision, RoutesConfig.pages.individualRequests],
            children: [
                {
                    itemName: SharedModels.CE.NavigationItemNames.BulkProvision,
                    routerLink: RoutesConfig.pages.bulkProvision,
                    availableForRoles: [
                        SharedModels.CE.UserRoleEnum.CsbaUS,
                        SharedModels.CE.UserRoleEnum.SecurityUS,
                        SharedModels.CE.UserRoleEnum.CsbaUSI
                    ],
                    queryParams: {}
                },
                {
                    itemName: SharedModels.CE.NavigationItemNames.IndividualRequests,
                    routerLink: RoutesConfig.pages.individualRequests,
                    availableForRoles: [
                        SharedModels.CE.UserRoleEnum.CsbaUS,
                        SharedModels.CE.UserRoleEnum.SecurityUS,
                        SharedModels.CE.UserRoleEnum.CsbaUSI
                    ],
                }
            ]
        },
        {
            itemName: SharedModels.CE.NavigationItemNames.WorkPermit,
            routerLink: RoutesConfig.pages.workPermit,
            queryParams: {categoryId: SharedModels.CE.BadgeRequestsCategoryId.MdfWorkPermit},
            availableForRoles: [
                SharedModels.CE.UserRoleEnum.SecurityUSI,
                SharedModels.CE.UserRoleEnum.CsbaUSI,
                SharedModels.CE.UserRoleEnum.BussinessApprover,
                SharedModels.CE.UserRoleEnum.TIApprover
            ]
        },
        {
            itemName: SharedModels.CE.NavigationItemNames.EmployeeSearch,
            routerLink: RoutesConfig.pages.employeeSearch,
            availableForRoles: [
                SharedModels.CE.UserRoleEnum.SecurityUS,
                SharedModels.CE.UserRoleEnum.SecurityUSI,
                SharedModels.CE.UserRoleEnum.CsbaUS,
                SharedModels.CE.UserRoleEnum.CsbaUSI,
                SharedModels.CE.UserRoleEnum.FrontDesk,
                SharedModels.CE.UserRoleEnum.FrontDeskUSI,
                SharedModels.CE.UserRoleEnum.FacilitatorUSI,
                // SharedModels.CE.UserRoleEnum.ApproverUSI,
            ]
        }
    ];

    IsEmployeeSearchAccessible: boolean = false;
    private isEmployeeSearchAccessibleSubject = new BehaviorSubject<boolean>(this.IsEmployeeSearchAccessible);
    isEmployeeSearchAccessible$: Observable<boolean> = this.isEmployeeSearchAccessibleSubject.asObservable();
    email:string="";
    constructor(
        private employeeBusinessService: EmployeeBusinessService,
        private adobeLaunchService: AdobeLaunchService,
        private employeeDataAccessService: EmployeeDataAccessService,
        private cookieConsentService: CookieConsentService,
    ) {
    }

    ngOnInit(): void {
        this.user$ = this.employeeBusinessService.userProfileService.userData$;
        this.userPhotoFile$ = this.user$.pipe(
            filter(Boolean),
            tap((userData: EmployeeModels.DM.IUserData) => {
                this.getRejectReasonsForCSBAandSA();
                this.getDeliveryLocationsForCsbaSaFd();
                this.checkEmployeeSearchAccess(userData.email);
            }),
            switchMap((userData: EmployeeModels.DM.IUserData) => {
                    return this.employeeDataAccessService.userData.getUserPhoto(userData.alias);
                }
            ));
        this.adobeLaunchService.trackPageTitleFromRouteData();
        this.cookieConsentService.init();
    }

    getRejectReasonsForCSBAandSA(): void {
        if (this.employeeBusinessService.userRoleService.isCSBA
            || this.employeeBusinessService.userRoleService.isSecurityAdmin) {
            this.employeeDataAccessService.staticDataService.fetchRejectReasons();
        }
    }

    getDeliveryLocationsForCsbaSaFd(): void {
        if (this.employeeBusinessService.userRoleService.isCSBA
            || this.employeeBusinessService.userRoleService.isSecurityAdmin
            || this.employeeBusinessService.userRoleService.isFrontDesk) {
            this.employeeDataAccessService.staticDataService.fetchDeliveryLocationList();
        }
    }

    checkEmployeeSearchAccess(email:string) {

    this.employeeDataAccessService.userData.getUserAccesForEmployeeSearch(email).subscribe(
        response => {
            this.IsEmployeeSearchAccessible = response;
            this.isEmployeeSearchAccessibleSubject.next(this.IsEmployeeSearchAccessible);
        }
    )
    }

}
